import React from 'react';
import Button from 'src/modules/shared/components/atoms/buttons/button';
import { Text } from 'src/modules/shared/components/atoms/text';
import Modal from 'src/modules/shared/components/molecules/modals/modal';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';

interface NotificationsPermissionModalProps {
  isOpen: boolean;
  loading?: boolean;
  onClose: () => void;
  onEnable: () => void | Promise<void>;
  onDismissPermanently: () => void;
}

export const NotificationsPermissionModal: React.FC<
  NotificationsPermissionModalProps
> = ({ isOpen, loading = false, onClose, onEnable, onDismissPermanently }) => {
  const { t } = useI18n();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      dialogClassName="!h-auto !max-h-[calc(100dvh-2rem)] w-[min(420px,calc(100vw-2rem))] !rounded-lg sm:max-w-[420px]"
      headerClassName="items-center pt-5"
      header={
        <div className="min-w-0 flex-1 text-left">
          <Text
            as="h2"
            size="h5"
            weight="semibold"
            className="text-left text-secondary-900"
          >
            {t('notifications.prompt.title')}
          </Text>
        </div>
      }
      body={
        <div className="flex w-full flex-col gap-5 py-2 sm:py-3">
          <Text size="paragraph" className="leading-7 text-secondary-600">
            {t('notifications.prompt.description')}
          </Text>
        </div>
      }
      footer={
        <div className="flex w-full flex-col gap-3 px-4 py-4">
          <Button
            size="lg"
            className="w-full justify-center"
            onClick={() => {
              void onEnable();
            }}
            loading={loading}
            disabled={loading}
          >
            {t('notifications.prompt.actions.enable')}
          </Button>

          <Button
            variant="neutral"
            appearance="ghost"
            size="lg"
            className="w-full justify-center text-secondary-600"
            onClick={onClose}
            disabled={loading}
          >
            {t('notifications.prompt.actions.notNow')}
          </Button>

          <Button
            variant="neutral"
            appearance="ghost"
            size="lg"
            className="w-full justify-center text-secondary-600"
            onClick={onDismissPermanently}
            disabled={loading}
          >
            {t('notifications.prompt.actions.dismiss')}
          </Button>
        </div>
      }
    />
  );
};
